import {
    addCommercialProRequest,
    addCommercialRequest,
    deleteCommercialRequest,
    editCommercialProRequest,
    editCommercialRequest,
    getCommercialListRequest,
    getCommercialRequest,
    updateCommercialRequest,
} from '../../../services/network/sell/commercial';

class CommonCommercialService {
    async addCommercial(values) {
        return await addCommercialRequest(values);
    }

    async addCommercialPro(values) {
        return await addCommercialProRequest(values);
    }

    async getCommercial(id) {
        return await getCommercialRequest(id);
    }

    async getCommercialList(payload) {
        return await getCommercialListRequest(payload);
    }

    async deleteCommercial(id) {
        return await deleteCommercialRequest(id);
    }

    async editCommercial(updates) {
        return await editCommercialRequest(updates);
    }

    async editCommercialPro(updates) {
        return await editCommercialProRequest(updates);
    }

    async updateCommercial(updates) {
        return await updateCommercialRequest(updates);
    }
}

export const CommercialService = new CommonCommercialService();
